<template>
  <div class="task-message">
    <div class="sender-info pull-left max-width">
      <div class="container-fluid profile-field">
        <div class="sender-img-wrap pull-left profile-avatar">
          <img :src="userProfileURL" class="rounded">
        </div>
        <div class="sender-details pull-left profile-details">
          <div>
            <span class="name-field">{{message.user.name}}</span>
            <span class="date-field pull-right">{{message.created_at | moment("YYYY-MM-DD HH:mm") }}</span>
          </div>
          <div class="message-text">"{{message.message}}"</div>
        </div>
        <div class="clearfix"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TaskMessage",
  components: {},
  props: {
    message: {
      type: Object
    }
  },
  data() {
    return {};
  },
  created() {},
  computed: {
    userProfileURL() {
      if (this.message.user && this.message.user.profile_image_url) {
        return this.message.user.profile_image_url;
      }
      return "static/avatar.png";
    }
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.task-message {
  min-height: 100px;
  margin: 10px 0;
  .message-text {
    font-style: italic;
  }

  .sender-info {
    border-top: 1px solid #eee;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modules/tasks/TaskMessage.vue